import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import WhiteHatSentinelMappingForm from './WhiteHatSentinelMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function WhiteHatSentinelCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        rules:[urlRegexValidator],
    }, {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            toolDisplayName="WhiteHat Sentinel"
            MappingForm={WhiteHatSentinelMappingForm}
            initialValue={{apiEndpoint:"https://sentinel.Whitehatsec.com"}}
            config={ props.config && { apiEndpoint:"https://sentinel.Whitehatsec.com", ...props.config }}
            />
    )
}

export default forwardRef(WhiteHatSentinelCredentialsForm);